import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useHttp } from '../hooks/http.hook';
import { AuthContext } from '../context/AuthContex';
import { SlotList } from '../components/SlotList';
import { Pagination } from 'react-bootstrap';

export const SlotsCatalog = () => {
    const { api_key } = useContext(AuthContext);
    const [slots, setSlots] = useState([]);
    const [meta, setMeta] = useState({ current_page: 1, last_page: 1 });
    // const [cache, setCache] = useState({});

    const { request } = useHttp();

    const fetchSlots = useCallback(async (page = 1) => {
        // if (cache[page]) {
        //     setSlots(cache[page].data);
        //     setMeta((prevMeta) => ({ ...prevMeta, ...cache[page].meta }));
        //     return;
        // }

        try {
            const headers = new Headers({
                "Content-Type": "application/json",
                "Origin": window.location.origin,
                "Accept": "application/json"
            });

            const fetched = await request(`https://slotslaunch.com/api/games?token=${api_key}&page=${page}`, 'GET', null, headers);
            // console.log(fetched);

            if (!fetched.data || !fetched.meta) {
                console.error('Failed to fetch slots:', fetched);
                throw new Error('Failed to fetch slots');
                return;
            }

            setSlots(fetched.data);
            setMeta(fetched.meta);

            // setCache((prevCache) => {
            //     const newCache = {
            //         ...prevCache,
            //         [page]: {
            //             data: fetched.data,
            //             meta: fetched.meta,
            //         },
            //     };
            //     sessionStorage.setItem('cache', JSON.stringify(newCache));
            //     return newCache;
            // });

            sessionStorage.setItem('slots', JSON.stringify(fetched.data));
            sessionStorage.setItem('meta', JSON.stringify(fetched.meta));
        } catch (e) {
            console.error('Failed to fetch slots:', e);
        }
    }, [request, api_key/*, cache*/]);

    useEffect(() => {
        const savedSlots = sessionStorage.getItem('slots');
        const savedMeta = sessionStorage.getItem('meta');
        // const savedCache = sessionStorage.getItem('cache');

        if (savedSlots && savedMeta /*&& savedCache*/) {
            setSlots(JSON.parse(savedSlots));
            setMeta(JSON.parse(savedMeta));
            // setCache(JSON.parse(savedCache));
        } else {
            fetchSlots(meta.current_page);
        }
    }, []); // Note the empty dependency array here

    const handlePageChange = (pageNumber) => {
        setMeta((prevMeta) => ({ ...prevMeta, current_page: pageNumber }));
        fetchSlots(pageNumber);
    };

    const renderPaginationItems = () => {
        const items = [];
        const maxItemsToShow = 5;
        const { current_page, last_page } = meta;

        let startPage = Math.max(1, current_page - Math.floor(maxItemsToShow / 2));
        let endPage = startPage + maxItemsToShow - 1;

        if (endPage > last_page) {
            endPage = last_page;
            startPage = Math.max(1, endPage - maxItemsToShow + 1);
        }

        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={page === current_page}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <Fragment>
            <Pagination>
                <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.current_page === 1} />
                <Pagination.Prev onClick={() => handlePageChange(meta.current_page - 1)} disabled={meta.current_page === 1} />
                {renderPaginationItems()}
                <Pagination.Next onClick={() => handlePageChange(meta.current_page + 1)} disabled={meta.current_page === meta.last_page} />
                <Pagination.Last onClick={() => handlePageChange(meta.last_page)} disabled={meta.current_page === meta.last_page} />
            </Pagination>
            <SlotList slots={slots} />
        </Fragment>
    );
};
